import React from 'react';

function BulletListIcon() {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			fill='none'
			viewBox='0 0 24 24'
		>
			<path
				stroke='#141414'
				strokeLinecap='round'
				strokeWidth='1.5'
				d='M4 5h12'
			></path>
			<path
				stroke='#141414'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth='2'
				d='M20 5h.009M20 12h.009M20 19h.009'
			></path>
			<path
				stroke='#141414'
				strokeLinecap='round'
				strokeWidth='1.5'
				d='M4 12h12M4 19h12'
			></path>
		</svg>
	);
}

export default BulletListIcon;
